import React, { useState } from "react";
import { apiFetch, canAccessFolder, validateFolderAccess } from "../utils/wkCommon";
import { isZh } from "../utils/language";

export default function FolderTreeNode({ user, folder, activeFolder, onSelect, level = 0 }) {
  const [confirmMove, setConfirmMove] = useState(null);
  const [dragOver, setDragOver] = useState(false);
  const [dragValid, setDragValid] = useState(true);

  if (!canAccessFolder(folder, user)) {
    return null;
  }

  function handleDragStart(e) {
    e.dataTransfer.setData("folderId", folder.documentId);
  }

  async function handleDrop(e) {
    setDragOver(false);
    const folderId = e.dataTransfer.getData("folderId");
    if (!folderId || folderId === folder.documentId) return;

    setConfirmMove(folderId);
  }

  function checkDropAllowed(movingId) {
    // cari folder yg sedang di-drag
    const moving = folder.children?.find(f => f.documentId === movingId);

    if (!moving) return true; // fallback (biar tidak block)

    const check = validateFolderAccess({
      ...moving,
      document_folder: folder
    });

    return !check?.warning;
  }

  function canDropHere(movingFolder) {
    const check = validateFolderAccess({
      ...movingFolder,
      document_folder: folder
    });

    return !check?.warning;
  }  

  async function confirmMoveFolder() {
    // ambil folder yang mau dipindah
    const moving = folder.children?.find(f => f.documentId === confirmMove);

    const check = validateFolderAccess({
      ...moving,
      document_folder: folder
    });

    if (check?.warning) {
      alert(check.message);
      setConfirmMove(null);
      return;
    }

    await apiFetch(`/api/document-folders/${confirmMove}`, {
      method: "PUT",
      body: {
        data: {
          document_folder: folder.documentId,
          recordEditor: user?.email || "system",
        },
      },
    });

    setConfirmMove(null);
    onSelect(folder);
  }

  function getFolderIcon(folder) {
    switch (folder.access_type) {
      case "public":
        return "🌐📁";
      case "authenticated":
        return "🔐📁";
      case "role_based":
        return "🛡️📁";
      default:
        return "📁";
    }
  }

  return (
    <>
      <style>{`
        .folder-node.drag-valid {
          background: rgba(0, 180, 0, 0.15);
        }

        .folder-node.drag-invalid {
          background: rgba(255, 0, 0, 0.15);
          cursor: not-allowed;
        }
      `}</style>
      <div
        className={`folder-node ${
            activeFolder?.documentId === folder.documentId ? "active" : ""
          } ${
            dragOver ? (dragValid ? "drag-valid" : "drag-invalid") : ""
          }`}
        style={{ paddingLeft: `${level * 1.2}rem` }}
        draggable
        onDragStart={handleDragStart}
        onClick={() => onSelect(folder)}
        onDragOver={e => {
            e.preventDefault();

            const movingId = e.dataTransfer.getData("folderId");

            const valid = checkDropAllowed(movingId);

            setDragOver(true);
            setDragValid(valid);
          }}
        onDragLeave={() => {
            setDragOver(false);
          }}          
        onDrop={handleDrop}
      >
        {getFolderIcon(folder)} {isZh() ? folder.name_zh : folder.name}
      </div>

      {confirmMove && (
        <>
          <style>{`
            .ftn-overlay {
              position: fixed;
              inset: 0;
              background: rgba(0,0,0,0.3);
              display: flex;
              align-items: center;
              justify-content: center;
              z-index: 9999;
            }

            .ftn-dialog {
              background: white;
              padding: 1rem;
              border-radius: 0.6rem;
              min-width: 20rem;
              box-shadow: 0 8px 20px rgba(0,0,0,0.2);
            }

            .ftn-actions {
              display: flex;
              justify-content: flex-end;
              gap: 0.5rem;
              margin-top: 0.8rem;
            }
          `}</style>

          <div className="ftn-overlay" onClick={() => setConfirmMove(null)}>
            <div className="ftn-dialog" onClick={(e)=>e.stopPropagation()}>
              <p>
                Move this folder as sub-folder of "{folder.name}"?
              </p>

              <div className="ftn-actions">
                <button onClick={() => setConfirmMove(null)}>Cancel</button>
                <button onClick={confirmMoveFolder}>Yes</button>
              </div>
            </div>
          </div>
        </>
      )}

      {folder.children?.map(c => (
        <FolderTreeNode
          key={c.documentId}
          user={user}
          folder={c}
          activeFolder={activeFolder}
          onSelect={onSelect}
          level={level + 1}
        />
      ))}

    </>
  );
}
